import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import reactImage from '../../images/cardpageimages/technicalcourse/reactimage.png';
import IntroVideos from "../../componants/introvideos";
import ReactModule from "../../componants/allCourseModule/TechnicalCourseModule/ReactModule";

function ReactCourse() {
  return (
    <>
      <Header />
      <BannerForAll
        title="REACT FULL COURSE"
        text="Our React Full Course is designed to help you master the fundamentals of React, including component-based architecture, state management, hooks, and advanced concepts. Ideal for web developers, this course equips you to build modern, responsive, and dynamic web applications using React, empowering you to excel in front-end development."
        imageone={reactImage}
        imagetwo={reactImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="REACT"
      />
      <ReactModule />
      <Footer />
    </>
  );
}

export default ReactCourse;
